import { helpers, pr, theme, ui } from "aaa";
import { observer } from "mobx-react";
import { themeColors } from "muiTheme";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import toastSore from "stores/ToastStore";
import { CancelButton } from "../components/CancelButton";
import { UserNumberCard } from "../components/cards/UserNumberCard";
import { ContinueButton } from "../components/ContinueButton";
import { JuniorInfoBox } from "../components/JuniorInfoBox";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";

type IProps = { store: JuniorStore };

export const JuniorActivationActivateUser = observer(({ store }: IProps) => {
    const userNumber = store.selectedChild?.userNumber?.toString() ?? "";

    const handleClose = () => {
        pushRoute(JuniorRoutes.DETAIL);
    };

    const handleCopy = () => {
        helpers.copyTextToClipboard(userNumber);
        toastSore.addMessage(ui.__("sidentitySettings.usernumberCopied"));
    };

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activation.user.title")}
            ContinueButton={<ContinueButton
                messageId="gJunior.activation.user.generateQrButton"
                onClick={() => { pushRoute(JuniorRoutes.ACTIVATION_CODE); }}
            />}
            CancelButton={<CancelButton onClick={handleClose} />}
        >
            <pr.P_16_CONTENT style={{
                marginTop: theme.MARGIN_SMALL,
            }}>
                {ui.__("gJunior.activation.user.description")}
            </pr.P_16_CONTENT>

            <pr.P_14_TITLE style={{
                fontWeight: 600,
                marginTop: theme.MARGIN,
                marginBottom: theme.MARGIN_SMALL,
            }}>
                {ui.__("gJunior.activation.user.userNumberLabel")}
            </pr.P_14_TITLE>

            <UserNumberCard value={userNumber} onCopy={handleCopy} />

            <JuniorInfoBox style={{ marginTop: theme.MARGIN }}>
                <pr.P_14_CONTENT style={{ margin: 0, color: ui.isDarkMode ? themeColors.grey_100 : themeColors.george_text_color }}>
                    {ui.__("gJunior.activation.user.infoText")}
                </pr.P_14_CONTENT>
            </JuniorInfoBox>
        </ScreenWithBottomAction>
    );
});



// WEBPACK FOOTER //
// ./src/components/gJunior/activationStep/JuniorActivationActivateUser.tsx